import { render, staticRenderFns } from "./usedWangList.vue?vue&type=template&id=c974b8a0&scoped=true"
import script from "./usedWangList.vue?vue&type=script&lang=js"
export * from "./usedWangList.vue?vue&type=script&lang=js"
import style0 from "./usedWangList.vue?vue&type=style&index=0&id=c974b8a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c974b8a0",
  null
  
)

export default component.exports